<template>
  <v-app>
    <v-app-bar density="compact" :elevation="2" color="primary"
      v-if="$vuetify.display.mobile" scroll-behavior="hide">

      <template v-slot:prepend>
        <v-app-bar-nav-icon @click.stop="isVisibleDrawer = !isVisibleDrawer; isShrinkDrawer = false"></v-app-bar-nav-icon>
      </template>

      <v-app-bar-title></v-app-bar-title>
    </v-app-bar>

    <v-navigation-drawer v-bind:rail="!$vuetify.display.mobile" expand-on-hover @update:rail="drawerStateDetector"
      :elevation="5" color="primary" class="thin-scrollbar" v-model="isVisibleDrawer">

      <v-list nav>
        <v-list-subheader color="sidebar_subheader" v-bind:class="{ 'v-hidden': isShrinkDrawer }">
          画面切り替え
        </v-list-subheader>

        <v-list-item value="tile" to="tile">
          <template v-slot:prepend>
            <v-icon>mdi-view-dashboard-outline</v-icon>
          </template>

          <v-list-item-title>タイル表示</v-list-item-title>
        </v-list-item>

        <v-list-item value="monitor" to="monitor" v-if="!$vuetify.display.mobile">
          <template v-slot:prepend>
            <v-icon>mdi-chart-line</v-icon>
          </template>

          <v-list-item-title>グラフ表示</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" :thickness="1" color="sidebar_subheader" v-if="!$vuetify.display.mobile"></v-divider>

        <v-list-item value="csv-download" to="csv-download" v-if="!$vuetify.display.mobile">
          <template v-slot:prepend>
            <v-icon>mdi-folder-download-outline</v-icon>
          </template>

          <v-list-item-title>CSVダウンロード</v-list-item-title>
        </v-list-item>

        <v-divider class="mt-2 mb-3" :thickness="1" color="sidebar_subheader"></v-divider>

        <v-list-item value="remote-control" to="remote-control">
          <template v-slot:prepend>
            <v-icon>mdi-remote</v-icon>
          </template>

          <v-list-item-title>モジュール遠隔操作</v-list-item-title>
        </v-list-item>

        <v-list-item value="action-log" to="action-log">
          <template v-slot:prepend>
            <v-icon>mdi-text-box-search-outline</v-icon>
          </template>

          <v-list-item-title>動作ログ</v-list-item-title>
        </v-list-item>

        <v-divider class="mt-4 mb-3" :thickness="2" color="sidebar_subheader"></v-divider>

        <v-list-group>
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props">
              <template v-slot:prepend>
                <v-icon>mdi-cog</v-icon>
              </template>

              <v-list-item-title>設定</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item value="monitor-edit" to="monitor-edit" :active="(isShrinkDrawer) ? false : undefined">
            <template v-slot:prepend>
              <v-icon>mdi-monitor-edit</v-icon>
            </template>

            <v-list-item-title>表示設定</v-list-item-title>
          </v-list-item>

          <v-list-item value="module-settings" to="module-settings" :active="(isShrinkDrawer) ? false : undefined">
            <template v-slot:prepend>
              <v-icon>mdi-tools</v-icon>
            </template>

            <v-list-item-title>モジュール設定</v-list-item-title>
          </v-list-item>

        </v-list-group>

        <v-divider class="my-3" :thickness="2" color="sidebar_subheader"></v-divider>

        <v-list-item value="announce" to="announce">
          <template v-slot:prepend>
            <v-icon>mdi-bullhorn</v-icon>
          </template>
          <v-list-item-title>お知らせ</v-list-item-title>
        </v-list-item>

      </v-list>

      <v-divider class="mt-2" :thickness="2" color="sidebar_subheader" v-if="!$vuetify.display.mobile"></v-divider>

      <v-list nav v-model:selected="displayMode" v-if="!$vuetify.display.mobile">
        <v-list-subheader color="sidebar_subheader" v-bind:class="{ 'v-hidden': isShrinkDrawer }">
          表示切り替え
        </v-list-subheader>

        <v-list-item value="fullscreen" @click="toggleFullScreen">
          <template v-slot:prepend>
            <v-icon>mdi-fullscreen</v-icon>
          </template>

          <v-list-item-title>フルスクリーン</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider class="mt-2" :thickness="2" color="sidebar_subheader"></v-divider>

      <v-list nav>
        <v-list-group>
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" :disabled="!isAuthenticated">
              <template v-slot:prepend>
                <v-icon>mdi-account</v-icon>
              </template>

              <v-list-item-title>{{ userName }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item value="logout" v-on:click="logout">
            <template v-slot:prepend>
              <v-icon>mdi-logout-variant</v-icon>
            </template>

            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

    </v-navigation-drawer>

    <v-main>

      <router-view v-if="isAuthenticated" />

      <authentication-view v-else />

    </v-main>
  </v-app>
</template>

<script>
import { ref, onMounted } from 'vue';

import AuthenticationView from './views/AuthenticationView.vue';

export default {
  components: {
    AuthenticationView
  },

  setup() {

    const isAuthenticated = ref(false);
    const userName = ref('アカウント');

    const isVisibleDrawer = ref(null);
    const isShrinkDrawer = ref(true);

    const displayMode = ref([]);


    const accessToken = window.sessionStorage.getItem('access-token');
    if (accessToken != null) {
      isAuthenticated.value = true;

      userName.value = window.sessionStorage.getItem('user-name');
    }


    onMounted(() => {

      document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement == null) {
          displayMode.value = [];
        }
      });

    });

    const drawerStateDetector = (isShrink) => {
      isShrinkDrawer.value = isShrink;
    };

    const toggleFullScreen = () => {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.body.requestFullscreen();
      }
    };

    const logout = () => {
      window.sessionStorage.clear();
      window.location.reload();
    };

    return {
      isAuthenticated,
      userName,

      isVisibleDrawer,
      isShrinkDrawer,

      displayMode,

      drawerStateDetector,
      toggleFullScreen,
      logout
    }
  }
}
</script>

<style>
#app {
  font-family: "Noto Sans JP", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* フルスクリーン時に画面がスクロールできなくなる問題に対処 */
  height: 100dvh;
  overflow-y: auto;
}

.v-hidden {
  visibility: hidden;
}

.thin-scrollbar ::-webkit-scrollbar {
  display: none;
  width: 5px;
}

.thin-scrollbar:hover ::-webkit-scrollbar {
  display: block;
}

.thin-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #757575C0;
  border-radius: 3px;
}
</style>
